// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__lOMAE","title":"Images45_title__8tuy8","images":"Images45_images__3AJCL"};